export const eventSocialNetworks = () => {
    const socialNetworks = document.querySelector('.social-networks');
    if (socialNetworks) {
        const buttons = socialNetworks.querySelectorAll('a') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const socialNetwork = button.getAttribute('data-name') || 'na';

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'reseauSocial': socialNetwork,
                    'event': 'clicReseauSocial'
                });
            });
        });
    }
}
